import React, { FC } from 'react'

import { locale } from '../../locales/locale'
import { useAppSelector } from '../../redux/hooks'
import { RelatedArticlesContainer } from '../common.components'
import { RelatedArticle } from '../definitions'
import { RelatedArticleTitle } from './article.components'

interface Props {
  changeView: (searchKey: string, page: string) => void
  relatedArticles: RelatedArticle[]
}

const RelatedArticles: FC<Props> = ({ changeView, relatedArticles }: Props) => {
  const editorModeActive = useAppSelector((state) => state.editor.value)

  const renderViewOnly = () => {
    return (
      <ul>
        {relatedArticles.map((article, idx) => {
          return (
            <li
              key={idx}
              onClick={() => changeView(article.permalink, 'articolo')}
            >
              <span>{article.title}</span>
            </li>
          )
        })}
      </ul>
    )
  }
  return (
    <RelatedArticlesContainer>
      <RelatedArticleTitle>{locale('Articoli correlati')}</RelatedArticleTitle>
      {!editorModeActive && renderViewOnly()}
    </RelatedArticlesContainer>
  )
}

export default RelatedArticles
